"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftSegmentDto = exports.CreateDraftSegmentDto = exports.SegmentDto = void 0;
const enums_service_1 = require("../../services/enums.service");
class BaseSegmentDto {
    constructor() {
        this.sportId = enums_service_1.SportsEnum.OTHER;
    }
}
class SegmentDto extends BaseSegmentDto {
}
exports.SegmentDto = SegmentDto;
class BaseDraftSegmentDto extends BaseSegmentDto {
}
class CreateDraftSegmentDto extends BaseDraftSegmentDto {
}
exports.CreateDraftSegmentDto = CreateDraftSegmentDto;
class DraftSegmentDto extends BaseDraftSegmentDto {
}
exports.DraftSegmentDto = DraftSegmentDto;
//# sourceMappingURL=segment.dto.js.map